import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  filterValues: {
    branchArray: [],
    branchValue: "",
    applicationArray: [],
    applicationValue: "",
  },
  touchHandler: {
    branchTouched: false,
    applicationTouched: false,
  },
  valueIsValid: {
    branchIsValid: false,
    applicationIsValid: false,
  },
};
const RepaymentStructureFilterReducer = createSlice({
  name: "repaymentStructureFilter",
  initialState: initialState,
  reducers: {
    updateBranchArray(state, action) {
      state.filterValues.branchArray = action.payload;
    },
    updateBranchValue(state, action) {
      state.filterValues.branchValue = action.payload;
      state.valueIsValid.branchIsValid =
        action.payload !== "" && action.payload !== null;
    },
    updateApplicationArray(state, action) {
      state.filterValues.applicationArray = action.payload;
    },
    updateApplicationValue(state, action) {
      state.filterValues.applicationValue = action.payload;
      state.valueIsValid.applicationIsValid =
        action.payload !== "" && action.payload !== null;
    },
    //Reducer for touch handler
    updateBrachIsTouched(state, action) {
      state.touchHandler.branchTouched = action.payload;
    },
    updateApplicationNumberIsTouched(state, action) {
      state.touchHandler.applicationTouched = action.payload;
    },
    resetFilterValues(state, action) {
      state.filterValues.branchArray = [];
      state.filterValues.branchValue = null;
      state.filterValues.applicationArray = [];
      state.filterValues.applicationValue = null;
    },
  },
});
export const RepaymentStructureFilterReducerAction =
  RepaymentStructureFilterReducer.actions;
export default RepaymentStructureFilterReducer.reducer;
